/**
 * Enum for PaymentManager's confirmation strategy.
 * Used on multiple levels on PaymentHandlers and PaymentGateways,
 * and kept in this file to avoid dependency cycles.
 */
export enum PAYMENT_MANAGER_CONFIRMATION_STRATEGY {
  MANUAL_CARD_ENTRY = "manual_card_entry",
  WALLET = "wallet",
  BUY_NOW_PAY_LATER = "buy_now_pay_later",
}
